import { Component } from '@angular/core';
import { soundpostConfigKeyEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Config Keys') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostconfigkey-form',
    templateUrl: './soundpostconfigkey.form.component.html'
})
export class soundpostConfigKeyFormComponent extends BaseFormComponent {
    public record!: soundpostConfigKeyEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

